<img class="tw-preview-not-found" alt="{{alt}}" src="assets/error-preview.png" />
